var _Int16_value;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Exception from '../../Exceptions/Exception';
import { ensureInt } from "./ensureInt";
import Result from '../../Result/Result';
export default class Int16 extends Number {
    constructor(value) {
        super(value);
        _Int16_value.set(this, void 0);
        ensureInt(value, Int16.minValue, Int16.maxValue);
        __classPrivateFieldSet(this, _Int16_value, value, "f");
    }
    [(_Int16_value = new WeakMap(), Symbol.toPrimitive)]() {
        return this.valueOf();
    }
    valueOf() {
        return __classPrivateFieldGet(this, _Int16_value, "f").valueOf() & 0xFFFF;
    }
    toString() {
        return this.valueOf().toString();
    }
    static parse(value) {
        const int = parseInt(value);
        return new Int16(int);
    }
    static tryParse(value) {
        const int = parseInt(value);
        try {
            ensureInt(int, Int16.minValue, Int16.maxValue);
            return Result.ok(new Int16(int));
        }
        catch (ex) {
            if (ex instanceof Exception) {
                return Result.fail(ex.message);
            }
            else if (ex instanceof Error) {
                return Result.fail(ex.message);
            }
            else {
                return Result.fail(`${ex}`);
            }
        }
    }
}
/** The largest number that can be represented. Equal to 32767. */
Int16.maxValue = 32767;
/** The lowest number that can be represented. Equal to -32768. */
Int16.minValue = -32768;
